export { default } from "./RewardIcon";
